import type { JSX } from 'react'
import type { INDENTS } from 'vars/indents'

import { Icon, IconNames } from 'atoms/Icon'
import { IconSizes } from 'atoms/Icon/Icon.h'
import { TextBoxMaxLine2FontSmBold } from 'atoms/TextBox/Templates'
import { TextAligning } from 'atoms/TextBox/TextBox.h'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { LAYOUT } from 'vars/layout-settings'
import { NoSearchResultsSC } from './NoSearchResults.styled'

interface INoSearchResultsProps {
  title: string
  icon?: boolean
  paddings?: Array<FIXED_INDENTS | INDENTS | LAYOUT>
}

export const NoSearchResults = ({
  title,
  icon = true,
  paddings = [
    FIXED_INDENTS.INDENT_0,
    LAYOUT.HorizontalPaddings,
    FIXED_INDENTS.INDENT_0,
    LAYOUT.HorizontalPaddings,
  ],
}: INoSearchResultsProps): JSX.Element => {
  return (
    <NoSearchResultsSC paddings={paddings}>
      {icon && <Icon name={IconNames.search} size={IconSizes.mSm} />}
      <TextBoxMaxLine2FontSmBold
        title={title}
        alignment={TextAligning.Center}
      />
    </NoSearchResultsSC>
  )
}
